<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dvY1gU/tc-custom/9781946578167.jpg?1731166618842" alt="This image is the cover for the book Fight Dirty, Renegade Justice"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fight Dirty, Renegade Justice
      </h1>
      <p class="bookDescription body article font2">
        <b>A teenage girl with a bloody past investigates a suspicious rehab center in the <i>New York Times</i>–bestselling author’s dark psychological thriller.</b><br/><br/>Morgan’s father, a convicted serial killer, raised her to follow in his sadistic footsteps. But now she’s determined to protect her freedom and not get locked away. So, despite ongoing temptation and a bloody past, Morgan swears off murder.<br/><br/>To tame her sociopathic instincts, Morgan cons her way into working with security consultants Jenna Galloway and Andre Stone. Suddenly, she’s going undercover to infiltrate a treatment center for troubled teens, investigating the suicide of a fourteen-year-old girl.<br/><br/>It isn’t long before Morgan realizes the patients are really in charge?and that some of their psychopathic tendencies rival her own. Even if she can discover the truth behind the girl’s death and escape alive, what?or who?might be waiting for her on the outside?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        CJ Lyons
      </h2>
      
      <p class="authorDescription body article"> New York Times and USA Today bestselling author of over forty novels, former pediatric ER doctor CJ Lyons has lived the life she writes about in her cutting-edge Thrillers with Heart. CJ has been called a &ldquo;master within the genre&quot; (Pittsburgh Magazine) and her work has been praised as &ldquo;breathtakingly fast-paced&rdquo; and &ldquo;riveting&rdquo; (Publishers Weekly) with &ldquo;characters with beating hearts and three dimensions&rdquo; (Newsday). Her novels have twice won the International Thriller Writers&rsquo; prestigious Thriller Award, the RT Reviewers&rsquo; Choice Award, the Readers&rsquo; Choice Award, the RT Seal of Excellence, and the Daphne du Maurier Award for Excellence in Mystery and Suspense. Learn more about CJ&rsquo;s Thrillers with Heart at www.CJLyons.net </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Edgy Reads
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0433384f